import { Component, OnInit } from '@angular/core';
import { GuestService } from 'src/app/shared/services/guest.service';

@Component({
  selector: 'app-activities-lite-check-out',
  templateUrl: './activities-lite-check-out.component.html',
  styleUrls: ['./activities-lite-check-out.component.scss',
    './../activities-lite.component.scss',
    '../activities-lite-order-summary/activities-lite-order-summary.component.scss']
})
export class ActivitiesLiteCheckOutComponent implements OnInit {

  constructor(public activityService: GuestService) {
    this.activityService.stopTimer();
   }

  ngOnInit(): void {
  }

}
